import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardWithForcedLogin} from 'app/core/auth-guard-with-forced-login.service';
import {BlankPageComponent} from 'app/main/blank-page/blank-page.component';
import {environment} from 'environments/environment';

const appRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuardWithForcedLogin],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: 'client-pred-analyza',
                loadChildren: () => import('app/main/client-pre-analyza/client-pre-analyza.module').then(m => m.ClientPreAnalyzaModule)
            },
            {
                path: 'client-detail',
                loadChildren: () => import('app/main/client-detail/client-detail.module').then(m => m.ClientDetailModule)
            },
            {
                path: 'client-documents',
                loadChildren: () => import('app/main/client-documents/client-documents.module').then(m => m.ClientDocumentsModule)
            },
            {
                path: 'client-portal',
                loadChildren: () => import('app/main/client-portal/client-portal.module').then(m => m.ClientPortalModule)
            },
            {
                path: 'client-financial-balance',
                loadChildren: () => import('app/main/client-financial-balance/client-financial-balance.module').then(m => m.ClientFinancialBalanceModule)
            },
            {
                path: 'financni-bilance-v2',
                loadChildren: () => import('@modules/financni-bilance-v2/financni-bilance-v2.module').then(m => m.FinancniBilanceV2WithRoutingModule)
            },
            {
                path: 'client-financial-plan',
                loadChildren: () => import('app/main/client-financial-plan/client-financial-plan.module').then(m => m.ClientFinancialPlanModule)
            },
            // {
            //     path: 'client-goals',
            //     loadChildren: () => import('app/main/client-goals/client-goals.module').then(m => m.ClientGoalsModule)
            // },
            {
                path: 'client-list',
                loadChildren: () => import('app/main/client-list/client-list.module').then(m => m.ClientListModule)
            },
            {
                path: 'client-new',
                loadChildren: () => import('app/main/client-new/client-new.module').then(m => m.ClientNewModule)
            },
            {
                path: 'client-import',
                loadChildren: () => import('app/main/client-import/client-import.module').then(m => m.ClientImportModule)
            },
            {
                path: 'client-search',
                loadChildren: () => import('app/main/client-search/client-search.module').then(m => m.ClientSearchModule)
            },
            {
                path: 'client-state-and-goals',
                loadChildren: () => import('app/main/client-state-and-goals/client-state-and-goals.module').then(m => m.ClientStateAndGoalsModule)
            },
            {
                path: 'client-tools',
                loadChildren: () => import('app/main/client-tools/client-tools.module').then(m => m.ClientToolsModule)
            },
            {
                path: 'service-introduction',
                loadChildren: () => import('app/main/service-introduction/service-introduction.module').then(m => m.ServiceIntroductionModule)
            },
            {
                path: 'financni-analyza',
                loadChildren: () => import('app/main/client-financni-analyza/client-financni-analyza.module').then(m => m.ClientFinancniAnalyzaWithRoutingModule)
            },
            {
                path: 'investicni-garant',
                loadChildren: () => import('app/main/investicni-garant/investicni-garant.module').then(m => m.InvesticniGarantWithRoutingModule)
            },
            {
                path: 'dev-form',
                loadChildren: () => import('app/main/dev-form/dev-form.module').then(m => m.DevFormModule)
            },
            {
                path: 'demo',
                loadChildren: () => import('@modules/_demo/demo.module').then(m => m.DemoModule)
            },
            {
                path: '',
                component: BlankPageComponent,
                pathMatch: 'full'
            },
            {
                path: '**',
                redirectTo: ''
            },
        ]
    }
];

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forRoot(appRoutes, {
            enableTracing: !environment.production,
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
            useHash: false,
        }),
    ],
    exports: [
        RouterModule,
    ]
})

export class AppRoutingModule {
}
